export default {
    "name": "CalculatePaymentDueDate",
    "kind": "HoudiniQuery",
    "hash": "c2a74324dd150f11fcdd89a5ad12e80bd93ca7d29e8b28fa3352b41071c78621",

    "raw": `query CalculatePaymentDueDate($termId: UInt, $documentDate: Date) {
  calculateSalesOrderDueDate(termId: $termId, documentDate: $documentDate)
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "calculateSalesOrderDueDate": {
                "type": "Date",
                "keyRaw": "calculateSalesOrderDueDate(documentDate: $documentDate, termId: $termId)",
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "termId": "UInt",
            "documentDate": "Date"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=a7247f00a62b49565d1dcfd44b562327e1a0fac47ba0a91bc00332f091608563";